<template>
  <div>
    <header>
      <navbar id="navbar"/>
    </header>
    <main>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <tabBar></tabBar>
    </main>
    <footer>
      <MunFooter id="munFooter"/>
    </footer>
    <!-- <rewards></rewards> -->
  </div>
</template>

<script>
import Navbar from "@/components/navbar";
import MunFooter from "@/components/munFooter";
import Rewards from "../components/rewards";
import tabBar from "../components/tabBar";

export default {
  name: "index",
  components: {
    Rewards,
    MunFooter,
    Navbar,
    tabBar,
  }
}
</script>



// WEBPACK FOOTER //
// src/view/index.vue